import React from "react";

import SignIn from "../components/Auth/SignIn";

const SignInPage = ({ location }) => <SignIn location={location}/>;

export default SignInPage;
